import { displayMessage } from "../../../services/helper"
import EDaysOfTheWeek from "../../../enums/EDaysOfTheWeek";
export default [
 {
field: 'name',
headerName: displayMessage('NAME'),
valueGetter: (params) => params.row?.name,
width:320
 },
 {
field: 'description',
headerName: displayMessage('DESCRIPTION'),
valueGetter: (params) => params.row?.description,
width:320
 },{
field: 'schedule-days',
headerName: displayMessage("SCHEDULE_DAYS"),
width:600,
valueGetter: (params) => {
  
  const days = params.row?.scheduledDays
  .sort((a, b) => a - b)
  .map((dayNumber) => {
    const day = Object.values(EDaysOfTheWeek).find(d => d.code === dayNumber);
    return day?.label;
  });

return days.join(', ');
  


}
 }
];